import React from "react";
import {NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import {useLocationFormState} from "../../components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm";
import CordwoodHistoryAddFormProvider from "../../components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CordwoodHistoryAddEditPage = () => {

    useTitle(t`Add Cordwood History`);

    return (
        <Box data-testid="CordwoodHistory-add-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="CordwoodHistory-add-title"
                    >
                        <Trans>Add Cordwood History</Trans>
                    </Typography>
                    <CordwoodHistoryAddFormProvider
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default CordwoodHistoryAddEditPage;
